import { useState, useEffect, useContext, useCallback } from 'react'
import OptionsContext from '../../utils/OptionsContext'

const useAnimation = ({
  rotation = 0,
  scale = 1,
  x = 0,
  y = 0,
  config = {
    type: 'spring',
    damping: 10,
    stiffness: 300,
  }
}) => {
  
  const { shouldReduceMotion } = useContext(OptionsContext).options
  const [isBooped, setIsBooped] = useState(false)
  
  const animate = {
    rotate: isBooped ? `${rotation}deg` : '0deg',
    scale: isBooped ? scale : 1,
    translateX: isBooped ? x : 0,
    translateY: isBooped ? y : 0,
    transition: config,
  }
  
  useEffect(() => {
    if (!isBooped) {
      return
    }
    const timeoutId = window.setTimeout(() => {
      setIsBooped(false)
    }, 150)
    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [isBooped])

  const trigger = useCallback(() => {
    setIsBooped(true)
  }, [])
  
  let appliedAnimation = shouldReduceMotion ? {} : animate
  
  return [appliedAnimation, trigger]
}

export default useAnimation